import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/font-awesome-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M397.8 67.8C405.6 67.8 412.1 74.4 412.1 82.1V429.7C412.1 437.5 405.5 444 397.8 444H50.2C42.4 444 35.9 437.4 35.9 429.7V82.2C35.9 74.4 42.5 67.9 50.2 67.9H397.8M397.8 32H50.2C22.7 32 0 54.7 0 82.2V429.8C0 457.3 22.7 480 50.2 480H397.8C425.3 480 448 457.3 448 429.8V82.2C448 54.7 425.3 32 397.8 32zM339.3 171.2C333.3 171.2 309.4 186.7 286.7 186.7 282.5 186.7 278.3 186.1 274.2 184.3 254.5 176.5 237.2 170.6 215.1 170.6 194.8 170.6 173.3 177.2 155.4 184.3 153.6 184.9 151.8 185.5 150.6 186.1V168.2C158.4 162.2 163.1 153.3 163.1 142.5 163.1 124.6 148.8 110.2 130.8 110.2S98.5 124.5 98.5 142.5C98.5 152.7 103.3 162.2 111 168.2V380.3C111 391.1 120 400 130.7 400 139.7 400 146.8 394 149.2 386.3V385C149.8 383.2 149.8 382 149.8 380.2V336C151 336 152.2 335.4 152.8 334.8 172.5 326.4 195.8 318.1 218.5 318.1 249.6 318.1 261.5 334.2 287.8 334.2 306.3 334.2 324.2 327.6 339.8 320.5 344 318.7 347 316.9 347 312.7V178.3C348.8 174.2 344.7 171.2 339.3 171.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/font-awesome-alt.js
// module id = LHAo
// module chunks = 144